import { ChangeDetectorRef, Injectable, Pipe, OnDestroy, PipeTransform, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { Observable, map } from 'rxjs';

import { Location } from '@fcom/core-api';

import { LocationsService } from '../services/locations.service';

@Injectable()
@Pipe({
  name: 'finLocationName',
  pure: false,
  standalone: false,
})
export class LocationNamePipe implements OnDestroy, PipeTransform {
  private ref = inject(ChangeDetectorRef);
  private locationsService = inject(LocationsService);

  private async: AsyncPipe;
  private cachedInputs: string[] = [];
  private location$: Observable<Location>;

  constructor() {
    this.async = new AsyncPipe(this.ref);
  }

  transform(key: string): string {
    this.location$ = this.locationsService.retrieveLocation(key);

    const locationName$: Observable<string> = this.location$.pipe(
      map((location: Location) => {
        if (!location) {
          if (!this.cachedInputs.includes(key)) {
            this.locationsService.triggerLocationFetch(key);
            this.cachedInputs.push(key);
          }

          return key;
        }

        if (!location.cityName && !location.title) {
          return key;
        }

        return location.cityName ? location.cityName : location.title;
      })
    );

    return this.async.transform(locationName$);
  }

  ngOnDestroy(): void {
    this.async.ngOnDestroy();
  }
}
